import Store from '../../stores/translations';
import Reflux from 'reflux';

const storeSingleton = Reflux.initStore(Store);

export default function translate (module, textUnit, variables) {
  return storeSingleton.get(module, textUnit, variables).text;
}

export function translateOrNull (module, textUnit, variables) {
  let translation = storeSingleton.get(module, textUnit, variables);
  return translation && translation.status === 0 ? translation.text : null;
}



// WEBPACK FOOTER //
// ./frontend/react/utils/translate/index.js